import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDetailContext } from '../contexts/DetailContext';

const Team = () => {
  const { t } = useTranslation();
  const { data } = useDetailContext();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <List>
        {!!data.teamMembers &&
          data.teamMembers.map((member) => (
            <ListItem key={member.id}>
              <ListItemText
                primaryTypographyProps={{ fontSize: '1.25rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
                primary={member.name}
                secondary={
                  <Box>
                    <Typography>
                      {t('Role', { defaultValue: 'Role' })}: {member.role},{' '}
                      {t('Status', { defaultValue: 'Status' })}: {member.status}
                    </Typography>
                    <Typography>
                      {t('Email', { defaultValue: 'Email' })}: {member.email || 'N/A'}
                    </Typography>
                    <Typography>
                      {t('Phone', { defaultValue: 'Phone' })}: {member.phone || 'N/A'}
                    </Typography>
                    <Typography>
                      {t('City', { defaultValue: 'City' })}: {member.city || 'N/A'}
                    </Typography>
                  </Box>
                }
              />
            </ListItem>
          ))}
      </List>
    </Box>
  );
};

export default Team;
